/** Lazy-load a route component. Works with both default and named exports.
 *  Auto-reloads on import failure (stale chunks after deployment).
 *  Passes through `handle` exports so route metadata can be colocated with components. */
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const lazy = (importFn: () => Promise<Record<string, any>>) => () =>
  importFn()
    .catch(() => {
      // Dynamic import failed — stale chunks after deployment. Reload to get new index.html.
      window.location.reload()
      return { default: () => null } as Record<string, unknown>
    })
    .then((m) => ({
      Component: m.default ?? Object.values(m).find((v) => typeof v === 'function'),
      ...(m.handle && { handle: m.handle }),
    }))
